"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var defaultValues = {
    getNowTime: function () { return new Date(); }
};
exports.DatetimeInputContext = react_1.createContext(defaultValues);
//# sourceMappingURL=DatetimeInputContext.js.map